import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container, Button, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import usePatch from '../../helpers/hooks/usePatch';
import usePost from '../../helpers/hooks/usePost';
import { AddLanguage } from './add-language';
import { LanguagesList } from './languages-list';

export const Languages = (props) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [languages, , languagesLoading, loadLanguages] = useGet(
    '/languages?filter[order]=createdAt DESC',
    true
  );
  const [postData, postedData, postingError, dataPosting] = usePost(
    '/languages'
  );
  const [updateData, updatedData, updatingError, dataUpdating] = usePatch('');
  const handleAddNewLanguage = (event, errors, values) => {
    console.log(values, errors);
    if (errors.length === 0) {
      postData({ ...values, isActive: true });
    }
  };
  const handleLanguagePatch = (id, data) => {
    updateData(data, `/languages/${id}`);
  };
  useEffect(() => {
    if (postedData) {
      setShowAddForm(false);
      loadLanguages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postedData]);
  useEffect(() => {
    if (updatedData) {
      loadLanguages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Languages</h4>
            <Button
              color='primary'
              onClick={() => setShowAddForm(!showAddForm)}
            >
              Add New Language
            </Button>
          </div>
          {showAddForm && (
            <AddLanguage onAdd={handleAddNewLanguage} disabled={dataPosting} />
          )}
          <Card>
            <CardBody>
              {languagesLoading || dataUpdating ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <LanguagesList
                  onUpdate={handleLanguagePatch}
                  data={languages?.map((x, i) => ({
                    ...x,
                    srNo: i + 1,
                    createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
                    updatedAt: dayjs(x.updatedAt).format('DD/MM/YYYY'),
                  }))}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};
